export default "<span (click)=\"selectTextTool()\" [class.active]=\"tool.active\">\n    <i class=\"fas fa-text-width\"></i>\n</span>\n"